import React from 'react';
import Header from '../../Layout/Header';
import Sidebar from '../../Layout/Sidebar';
import AccordionItemChecklist from '../../components/AccordionItemChecklist';
import HeroBanner from '../../components/HeroBanner';
import config from '../../config';
import { getChecklistStatus } from '../../utils/checklistUtils';
import { useChecklist } from '../../context/ChecklistContext';
import Breadcrumbs from '../../components/Breadcrumb';
import whatIsLCImg from '../../assets/images/siteImg/checklistImg/Image_WhatIsLC.png';
import whatLCDoImg from '../../assets/images/siteImg/checklistImg/Image_WhatLCDo.png';
import { FooterMobile } from '../../Layout/FooterMobile';
import bannerImage from '../../assets/images/banners/bannerImage_LearningCoach.png';

const MainChecklistLearningCoachLife: React.FC = () => {
    type ChecklistItem ={
        title: string;
        description: string;
        imageUrl: string;
        linkUrl: string;
        status: string;
    }
    const { HOME, SCHOOL_PREP_CHECKLIST, MAIN_CHECKLIST_DOMAIN, LEARNING_COACH_OVERVIEW_URL, LEARNING_COACH_ROLE_URL } = config.app.routes;
    const { checklistData, checklistTopicStatus } = useChecklist();
   
    // Filter checklist items for the "LEARNING_COACH_LIFE" category
    const getChecklistCategoryName = checklistData.filter(
        item => item.checklistCategoryName === "LEARNING_COACH_LIFE"
    );
    // Extract unique category name capitalization format
    const categoryName = getChecklistCategoryName.length > 0
    ? getChecklistCategoryName[0].checklistCategoryName
        .toLowerCase()
        .replace(/_/g, " ")
        .split(" ")
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "Learning Coach Life";

    // Prepare data from both frontend & API to each checklist item
    const checklistItems_arr = [
        {
            description: "See what to expect when you're involved in your child's education in this important support role.",
            imageUrl: whatIsLCImg
        },
        {
            description: 'Get the details of day-to-day duties and some great tips on how to support your student.',
            imageUrl: whatLCDoImg
        }
    ];
    const checklistWithStatus = getChecklistCategoryName.map((item, index) => ({
        ...checklistItems_arr[index],
        title: item.description,
        checklistId: item.checklistId,
        status: getChecklistStatus(item.checklistId, checklistTopicStatus),
        linkUrl: `${MAIN_CHECKLIST_DOMAIN}/${item.checklistName.toLowerCase().replace(/_/g, '-')}`,
    }));
    const breadcrumbItems = [
        { label: "Home", path: HOME },
        { label: "School Prep Checklist", path: SCHOOL_PREP_CHECKLIST },
        { label: categoryName }, 
    ];

    return (
    
        <div className="home-layout">
            <div className="sidebar-wrapper">
            <Sidebar />
            </div>
            <div className="body-wrapper-content">
            <div className="row">
                <div className="col-12">
                <Header />
                <main id="main" role="main">
                    <div className="main-content" id="form-doc-category">
                        <div className="row">
                            <div className="col-12">
                                <Breadcrumbs items={breadcrumbItems} />
                            </div>
                        </div>

                        <HeroBanner
                            title={categoryName}
                            subtitle="Shape your student's future!"
                            imageUrl={bannerImage}
                            altText={categoryName}
                            customClass="bg-color-blue-t1-checklist common-banner-bg-white"
                        />

                        <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex">
                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '66.66%' }}>
                            <div className="wp-block-k12-section container-fluid bg-transparent">
                                <div className="row">
                                    <div className="col-12 g-0">
                                        <div className="wp-block-k12-checklist-grid container-fluid">
                                            <div className="row">
                                                <div className="col-12">
                                                <ul>
                                                    {checklistWithStatus.map((item: ChecklistItem, index: number) => (
                                                        <AccordionItemChecklist
                                                        key={index}
                                                        title={item.title}
                                                        description={item.description}
                                                        imageUrl={item.imageUrl}
                                                        linkUrl={item.linkUrl}
                                                        status={item.status}
                                                        />
                                                    ))}
                                                </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '33.33%' }}>
                        </div>
                        </div>
                    </div>
                </main>
                </div>
            </div>

            </div>
            <FooterMobile />
        </div>  
    );
};
export default MainChecklistLearningCoachLife;